import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import moment from 'moment';
import cx from 'classnames';
import UnreadCount from './UnreadCount';

const formatDate = date => {
  const dateMoment = moment(date);
  if (dateMoment.isSame(moment(), 'day')) {
    return dateMoment.format('H:mm');
  }

  return dateMoment.format('DD/MM/YYYY');
};

class ThreadItem extends React.Component {
  static propTypes = {
    thread: PropTypes.object.isRequired,
    selected: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }

  onSelect() {
    this.props.onSelect(this.props.thread.recipient.id);
  }

  render() {
    const { thread, selected } = this.props;

    const isSelected =
      selected && selected.toString() === thread.recipient.id.toString();
    const segmentClass = cx('ui segment', {
      blue: isSelected,
      active: isSelected,
    });

    return (
      <div className={segmentClass} onClick={this.onSelect}>
        <UnreadCount thread={thread} />
        <div className="content">
          <div className="header">
            <span className="time">{formatDate(thread.message.sent_at)}</span>
            {thread.message.isStared && <i className="favorite icon" />}
            {thread.recipient.name || thread.recipient.email}
          </div>
          <div className="message">{thread.message.content}</div>
        </div>
      </div>
    );
  }
}

export default pure(ThreadItem);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ThreadItem.js